import { SPACING } from '@alto/design-library-tokens';
import { Body, LgPadding } from '@alto/design-system';
import React from 'react';
import { CONTACT_US_ORIGIN } from '~shared/constants';
import { ContactProgynyActionSheet } from './ContactProgynyActionSheet';

type Props = {
  readonly medicationNames: (string | null)[];
};

export const ExcessSupplyContactProgynyActionSheet = ({ medicationNames }: Props) => (
  <ContactProgynyActionSheet
    title="Contact us to schedule your delivery"
    origin={CONTACT_US_ORIGIN.ExcessSupplyContactUsActionSheet}
  >
    <LgPadding topPadding={SPACING.STATIC.NONE}>
      <Body>
        Since you have enough {medicationNames?.join(' and ') || 'medication'} to cover the beginning of your cycle,
        we’ll need to assist you with your order.
      </Body>
    </LgPadding>
  </ContactProgynyActionSheet>
);
